<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4hx9yh/tc-custom/9781504089937.jpg?1728851662322" alt="This image is the cover for the book Appleby Talks Again, The Inspector Appleby Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Appleby Talks Again, The Inspector Appleby Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>From a British mystery author “in a class by himself among detective story writers,” eighteen classic crime stories, perfect for astute armchair detectives (<i>The Times Literary Supplement</i>).</b><br/><br/>Scandal is at stake for London’s fashionable society when Edwardian playwright Richard Dangerfield’s sordid diary falls into the hands of a blackmailer. Though Dangerfield is long dead, those who consorted with him are all very much alive and at the respectable old age where they’d hoped such stories would follow them to their graves. Fortunately, Scotland Yard’s most brilliant inspector is on the case. Sir John Appleby wittily reveals his intellectual prowess in solving this crime, as well as seventeen other puzzling mysteries in this stimulating collection of short stories. From acclaimed Scottish author Michael Innes, <i>Appleby Talks Again </i>is a must-read for fans of classic crime fiction.<br/><br/><b>Praise for Michael Innes and the Inspector Appleby series</b><br/><br/><b>“Wickedly witty.” —<i>Daily Mail</i></b><br/><br/><b>“As farfetched and literary as Sayers” —<i>The Cambridge Companion to Crime Fiction</i></b><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Innes
      </h2>
      
      <p class="authorDescription body article">Michael Innes (1906&ndash;1994) was the pseudonym of John Innes MacKintosh &ldquo;J.I.M.&rdquo; Stewart. He was born in Edinburgh, Scotlandeducated at Oxford, and taught English at universities in the UK and Australia. Writing as J.I.M. Stewart he published a number of scholarly works, mainly critical studies of authors, including Joseph Conrad and Rudyard Kipling, as well as more than twenty works of fiction and a memoir. As Michael Innes, he published numerous mystery novels and short story collections, most featuring the Scotland Yard detective Inspector John Appleby.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agora Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39762f8c